import React from "react";
import "./AboutUsItem.css";

function AboutUsItem() {
  return (
    <div className="about_item">
      <div>
        <div className="about_first_item">
          <p>
          Fashion is about the way we dress ourselves, and it embodies our expression as a person.
            <br />
            MayaWears creates clothing that resonates with the contemporary person who values not just quality and style
             but also the essence behind every piece of clothing. Each of our pieces inspires one to feel beautiful,
              at ease, and unique. Inspired by the diverse cultures and contemporary trends of Nepal, each of 
              our pieces combines creative synergy with craftsmanship to offer fashion that is versatile, stylish, 
              and everyday applicable. <br /><br />
              In MayaWears, we believe that clothing is a means of empowerment rather than an adornment. 
              Our collection includes designs that respond dynamically to the changes in the world today-be
               it through vivid prints or the use of sustainable fabric in ensemble construction or even designs 
               that allow comfort and edgy best. Our hope is to provide pieces that take the wearers from an at-home
                lazy day to partying at night, through supporting local artisans and breaking the boundaries of modern fashion
          </p>
        </div>
        <div className="about_second_item">
          <h1>We Believe</h1>
          <p>Limits are Only Boundaries of the Mind. <br />Possibilities Are Boundless. <br />MAYA is Your Key  <br /> to Transforming the Ordinary.</p>
          <h1>Our passion and dedication are woven into every piece we create, ensuring that each product carries the essence of our love and craftsmanship.</h1>
        </div>
      </div>
    </div>
  );
}

export default AboutUsItem;
